import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import './SearchBar.scss';

interface SearchBarProps {
  value: string;
  onChange: (query: string) => void;
  onClear: () => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, onClear }) => {
  return (
    <div className="tutorial-search-bar">
      <InputGroup>
        <Form.Control
          type="text"
          placeholder="Buscar tutoriales o preguntas frecuentes..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </InputGroup>
    </div>
  );
};

export default SearchBar;
